BinderPrematch = window.BinderPrematch = (function () {
    const selectors = {

        vmSelectAll: '#sports-filter__select-all',
        vmSportsFilterItem: '.j-sports-filter-item',
        vmSportsFilterSelectButton: '.j-sports-filter-item-select-button',
        vmSportsFilterLinkButton: '.j-sports-filter-item-link-button',
        vmSportsFilterItemsContainer: '#vm-sports-filter-items',

        tbTable: '.events-table',
        tbEvent: '.events-table__body-row',
        searchEvent: '[search-event]',

        tbFavstar: '[tb-favstar]',
        searchFavstar: '[search-favstar]',


        emptyBetplace: '#empty_betplace',

        tbSport: '.events-table',
        tbExpandSport: '.js-expand-table',
        tbExpandHotTable: '.js-expand-hot-table',
        tbLeague: '.js-expand-league',
        tbHotEvents: '.js-expand-hot-events',
        tbLeagueBody: '.events-table__group-body',

        cmTimeOffset: '#cm-time_offset',

        pageScrollbarContainer: '#m-page-content-scrollbar-scrollarea',

        removeAll: '#prematch_favs-remove_all'
    };

    var vmSelectedClass = 'm-selected';


    var bindUI = function () {
        var body = app.body;

        // Toggle SportFilterItem v2.0
        body.on('click', selectors.vmSportsFilterItem + '[data-id]', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();

            var container = $(this),
                id = container.data('id');

            var isAllChecked = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem + ':not(.m-selected)').length > 0 ? false : true;
            var filterItemsLength = $(selectors.vmSportsFilterItem).length;

            if (isAllChecked && filterItemsLength > 1) {
                container.addClass('m-loading');
                Ajax.postJson("/Prematch/EnableOnlyOneItem", {
                    data: {
                        id: id
                    },
                    doCallAjaxViewParsers: false,
                    success: function (resp) {
                        app.ModeTablePrematch.update();
                        $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem).removeClass('m-selected');
                        $(selectors.vmSelectAll).prop('checked', false);
                        container.addClass('m-selected');

                        app.ModeTablePrematch.insertTable(resp.html);

                        container.removeClass('m-loading');
                    }
                });
            } else {
                toggleSportsFilterItem(id, container);
            }

            return false;
        });

        // Toggle SportFilter v3.0
        body.on('click', selectors.vmSelectAll, function () {
            const selectedClass = 'm-selected';

            var that = $(this),
                removingAll = !that.prop('checked'),
                allItems = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem);

            that.parent().parent().addClass('m-loading');
            Ajax.postJson("/Prematch/ToggleSportFilter", {
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTablePrematch.update();
                    if (removingAll) {
                        that.prop('checked', false);
                        allItems.removeClass(selectedClass);
                    }
                    else {
                        that.prop('checked', true);
                        allItems.addClass(selectedClass);
                    }

                    (app.ModeTablePrematch.isEmpty())
                        ? $(selectors.emptyBetplace).addClass('active')
                        : $(selectors.emptyBetplace).removeClass('active');

                    that.parent().parent().removeClass('m-loading');
                }
            });
            return false;
        });

        // Toggle SportTable v2.5
        body.on('click', selectors.tbExpandSport, function () {
            var that = $(this).closest('.events-table'),
                id = that.data('id');

            that.addClass('m-loading');
            if (that.hasClass('m-expanded')) {
                Ajax.postJson('/Prematch/CollapseNode', {
                    data: { id: id },
                    doCallAjaxViewParsers: false,
                    success: function () {
						that.removeClass('m-expanded').addClass('m-collapsed');
                        app.ModeTablePrematch.collapseTable(id);
                        that.removeClass('m-loading');
                    }
                });
                return false;
            }

            Ajax.postJson('/Prematch/ExpandSportsTable', {
                data: { id: id, groups: app.getUrlParams('groups') },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTablePrematch.updateTable(id);
                    that.removeClass('m-loading');
                }
            });
            return false;
        });

        var processCollapseNodes = function(nodes) {
            for (var i = 0; i < nodes.length; i++) {
                //league/hotgroups
                var that = $('.events-table__group[data-id=' + nodes[i] + ']');
                that.find(selectors.tbLeagueBody).remove();
                that.removeClass('m-expanded').addClass('m-collapsed');
                app.ModeTablePrematch.shrinkTable(nodes[i]);
            }
        };

        body.on('click', selectors.tbExpandHotTable, function () {
            var that = $(this).closest('.events-table'),
                id = that.data('id');

            that.addClass('m-loading');
            if (that.hasClass('m-expanded')) {
                Ajax.postJson('/Prematch/CollapseHotTable', {
                    data: {},
                    doCallAjaxViewParsers: false,
                    success: function () {
                        that.removeClass('m-expanded').addClass('m-collapsed');
                        app.ModeTablePrematch.collapseTable(id);
                        that.removeClass('m-loading');
                    }
                });
                return false;
            }

            Ajax.postJson('/Prematch/ExpandHotTable', {
                data: {},
                doCallAjaxViewParsers: false,
                success: function (data) {
                    app.ModeTablePrematch.updateTable(id);
                    that.removeClass('m-loading');

                    processCollapseNodes(data.CollapseNodes);
                }
            });
            return false;
        });

        // Toggle League v2.5
        body.on('click', selectors.tbLeague, function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();

            var that = $(this).closest('.events-table__group'),
                id = that.data('id'),
                tId = that.closest(selectors.tbSport).data('id');

            that.addClass('m-loading');
            if (that.hasClass('m-expanded')) {
                Ajax.postJson('/Prematch/CollapseNode', {
                    data: {
                        id: id
                    },
                    doCallAjaxViewParsers: false,
                    success: function () {
                        that.removeClass('m-expanded').addClass('m-collapsed');
                        that.find(selectors.tbLeagueBody).remove();
                        app.ModeTablePrematch.shrinkTable(tId);
                        that.removeClass('m-loading');
                    }
                });
                return false;
            }
            Ajax.postJson('/Prematch/ExpandLeague', {
                data: { id: id },
                doCallAjaxViewParsers: false,
                success: function (data) {
                    app.ModeTablePrematch.extendTable(tId);
                    that.removeClass('m-loading');

                    processCollapseNodes(data.CollapseNodes);
                }
            });
            return false;
        });

        body.on('click', selectors.tbHotEvents, function () {
            var that = $(this).closest('.events-table__group'),
                id = that.closest(selectors.tbSport).data('id');

            that.addClass('m-loading');
            if (that.hasClass('m-expanded')) {
                Ajax.postJson('/Prematch/CollapseHotEvents', {
                    data: {
                        id: id
                    },
                    doCallAjaxViewParsers: false,
                    success: function () {
                        that.removeClass('m-expanded').addClass('m-collapsed');
                        that.find(selectors.tbLeagueBody).remove();
                        app.ModeTablePrematch.shrinkTable(id);
                        that.removeClass('m-loading');
                    }
                });
                return false;
            }
            Ajax.postJson('/Prematch/ExpandHotEvents', {
                data: { id: id, groups: app.getUrlParams('groups') },
                doCallAjaxViewParsers: false,
                success: function (data) {
                    app.ModeTablePrematch.extendTable(id);
                    that.removeClass('m-loading');

                    processCollapseNodes(data.CollapseNodes);
                }
            });
            return false;
        });


        // Set TimeOffset v2.0
        body.on('change', selectors.cmTimeOffset, function () {
            Ajax.postJson("/Prematch/SetTimeOffset", {
                data: { to: $(this).val(), groups: app.getUrlParams('groups') },
                doCallAjaxViewParsers: false,
                success: function () {
                    app.ModeTablePrematch.update();
                    (app.ModeTablePrematch.isEmpty()) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');
                }
            });
            return false;
        });

        // Fave event v3.0
        body.on('click', (selectors.tbFavstar + ',' + selectors.searchFavstar), function (e) {

            var that = $(this),
                isRemovingFromFav = that.hasClass('m-active'),
                eventId = (that.is(selectors.tbFavstar)) ? that.closest(selectors.tbEvent).data('id') : that.closest(selectors.searchEvent).data('id'),
                dataIdFilter = '[data-id=' + eventId + ']',
                allStars = $.merge($(selectors.tbEvent + dataIdFilter).find(selectors.tbFavstar), $(selectors.searchEvent + dataIdFilter).find(selectors.searchFavstar));

            that.addClass('m-loading');
            Ajax.postJson(isRemovingFromFav ? "/Prematch/UnFaveEvent" : "/Prematch/FaveEvent", {
                data: {
                    id: eventId
                },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    if (resp && resp.Message) {
                        that.removeClass('m-active');
                        Tooltip.errorNode(that, resp.Message);
                        that.removeClass('m-loading');
                        return;
                    }

                    if (isRemovingFromFav) {
                        allStars.removeClass('m-active');
                        allStars.attr('bb-tool', window.Localization.getString('Scripts_Shared_Main.Accent_10', 'Добавить в избранное'));
                    }
                    else {
                        allStars.addClass('m-active');
                        allStars.attr('bb-tool', window.Localization.getString('Scripts_Shared_Main.Accent_11', 'Удалить из избранного'));
                    }

                    app.VerticalMenu.changeFavorites();

                    that.removeClass('m-loading');
                },
            });

            return;
        });
    };

    var bindFavoritesUI = function () {
        // Fave event v3.0
        app.body.on('click', (selectors.tbFavstar + ',' + selectors.searchFavstar), function (e) {

            var that = $(this),
                isRemovingFromFav = that.hasClass('m-active'),
                eventId = (that.is(selectors.tbFavstar)) ? that.closest(selectors.tbEvent).data('id') : that.closest(selectors.searchEvent).data('id'),
                dataIdFilter = '[data-id=' + eventId + ']',
                allStars = $.merge($(selectors.tbEvent + dataIdFilter).find(selectors.tbFavstar), $(selectors.searchEvent + dataIdFilter).find(selectors.searchFavstar));

            that.addClass('m-loading');
            Ajax.postJson(isRemovingFromFav ? "/Prematch/UnFaveEvent" : "/Prematch/FaveEvent", {
                data: {
                    id: eventId,
                },
                doCallAjaxViewParsers: false,
                success: function (resp) {
                    if (resp && resp.Message) {
                        that.removeClass('m-active');
                        Tooltip.errorNode(that, resp.Message);
                        that.removeClass('m-loading');
                        return;
                    }

                    if (isRemovingFromFav) {
                        allStars.removeClass('m-active');
                        var currentEvent = $(selectors.tbEvent + dataIdFilter),
                            parentTable = currentEvent.closest(selectors.tbTable);

                        if (parentTable.find(selectors.tbEvent).length <= 1) {
                            ModeTablePrematch.removeTable(parentTable.data('id'));

                            if (app.ModeTablePrematch.isEmpty()) {
                                $(selectors.emptyBetplace).addClass('active')
                                $(selectors.removeAll).hide();
                            } else {
                                $(selectors.emptyBetplace).removeClass('active');
                            };

                        }
                        else {
                            currentEvent.remove();
                        }
                        that.removeClass('m-loading');
                    }
                    else {
                        allStars.addClass('m-active');
                        Ajax.getJson("/Prematch/UpdateFavoritesBetPlace", {
                            success: function () {
                                app.ModeTablePrematch.update();
                                that.removeClass('m-loading');
                                $(selectors.emptyBetplace).removeClass('active');
                                $(selectors.removeAll).show();
                            }
                        });

                    }
                    app.VerticalMenu.changeFavorites();
                },
            });

            return false;
        });

        ConfirmButton.init(
            selectors.removeAll,
            function () { },
            '/Prematch/UnFaveAll',
            function (resp) {
                app.ModeTablePrematch.destroyTables();

                if (app.ModeTablePrematch.isEmpty()) {
                    $(selectors.emptyBetplace).addClass('active')
                    $(selectors.removeAll).hide()
                } else {
                    $(selectors.emptyBetplace).removeClass('active');
                    $(selectors.removeAll).show();
                };

                app.VerticalMenu.changeFavorites();
            }
        );

        (app.ModeTablePrematch.isEmpty()) ? $(selectors.removeAll).hide() : $(selectors.removeAll).show();
    };

    var unBindUI = function () {
        app.body
            .off('click', selectors.vmSportsFilterItem + '[data-id]')
            .off('click', selectors.vmSelectAll)
            .off('click', selectors.tbExpandSport)
            .off('click', selectors.tbLeague)
            .off('click', selectors.tbExpandHotTable)
            .off('click', selectors.tbHotEvents)

            .off('click', (selectors.tbFavstar + ',' + selectors.searchFavstar))
            .off('change', selectors.cmTimeOffset);

        ConfirmButton.dispose(selectors.removeAll);

    };

    var toggleSportsFilterItem = function (id, sportsFilterItemContainer, callback) {
        var removing = sportsFilterItemContainer.hasClass(vmSelectedClass),
            allItems = $(selectors.vmSportsFilterItemsContainer).find(selectors.vmSportsFilterItem),
            selectAllbtn = $(selectors.vmSelectAll);

        sportsFilterItemContainer.addClass('m-loading');
        Ajax.postJson("/Prematch/ToggleSportFilterItem", {
            data: {
                id: id,
            },
            doCallAjaxViewParsers: false,
            success: function (resp) {
                if (removing) {
                    app.ModeTablePrematch.removeTable(id);
                    sportsFilterItemContainer.removeClass(vmSelectedClass);
                }
                else {
                    if (resp.isempty && app.ModeTablePrematch.isEmpty()) {
                        $(selectors.emptyBetplace).fadeOut(150, function () { $(selectors.emptyBetplace).fadeIn(150); });
                    }
                    else {
                        var prevFilter = sportsFilterItemContainer.prevAll('.' + vmSelectedClass);
                        var insertAfterId = (prevFilter.length !== 0) ? prevFilter.data('id') : undefined;
                        app.ModeTablePrematch.insertTable(resp.html, insertAfterId);
                    }
                    sportsFilterItemContainer.addClass(vmSelectedClass);
                }

                selectAllbtn.prop('checked', (allItems.filter('.' + vmSelectedClass).length === allItems.length));
                (app.ModeTablePrematch.isEmpty()) ? $(selectors.emptyBetplace).addClass('active') : $(selectors.emptyBetplace).removeClass('active');

                sportsFilterItemContainer.removeClass('m-loading');

                if(callback) callback();
            }
        });
    }

    var scrollToTable = function(id) {
        var table = $(selectors.tbTable).filter('[data-id="' + id + '"]');

        if (table.length > 0) {
            $(selectors.pageScrollbarContainer).scrollTop(table.position().top - 40);
        }
    }

    var bind = function(justLoaded) { bindUI(); }
    var bindFavorites = function(justLoaded) { bindFavoritesUI(); }
    var unBind = function () { unBindUI(); }

    return {
        bind: bind,
        bindFavorites: bindFavorites,
        unBind: unBind,
        name: 'BinderPrematch',
        url: '/Prematch/GetViewSet'
    };

}());


ScopePrematch = (function () {
    function init() {
        app.VerticalMenu.init();
        app.ModeTablePrematch.init();
        app.Search.init('prematch');
    }

    function dispose() {
        app.ModeTablePrematch.dispose();
        app.VerticalMenu.dispose();
    }

    var start = function (justLoaded) { init(); };
    var stop = function () { dispose(); };

    return {
        start: start,
        stop: stop,
        name: 'ScopePrematch',
        url: 'PREMATCH',
        title: Localization.getString('Shared.Prematch', 'Линия')
    };
}());
